import script from "./SearchForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchForm.vue?vue&type=script&lang=ts&setup=true"

import "./SearchForm.vue?vue&type=style&index=0&id=e8d6eb88&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\energiehoch3-v2\\wp-content\\themes\\io.shop-energiehoch3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d6eb88"]])

export default __exports__